import React from "react";
import { zodiacIconMap } from "./index";

const HouseCard = ({ name, degree, icon, house, onHouseClick }) => {
  const ZodiacIcon = zodiacIconMap[house.zodiac] || null;

  return (
    <div
      className="flex items-center justify-between w-full p-3 border-b border-[#e5e7eb] cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={() => onHouseClick(house)}
    >
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
          {ZodiacIcon && <ZodiacIcon className="w-5 h-5 text-[#3F414E]" />}
        </div>
        <div>
          <p className="text-[#3F414E] text-start text-xs font-medium">{name}</p>
          <p className="text-black/60 text-start text-xs">{house.degree_formatted || `${degree}°`}</p>
        </div>
      </div>
      <div className="flex items-center gap-1 text-[#3F414E] justify-center text-xs">
        <div> {<ZodiacIcon className="w-3 h-3 text-[#676870]" />} </div>
        <div> {house.zodiac} </div>
      </div>
    </div>
  );
};

export default HouseCard;
